import gql from 'graphql-tag';

import type { Workspace } from 'src/data/workspace';
import { executeGqlQuery } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp, type GraphQLEdgesResult, unwrapEdges } from 'src/lib/graphql';

import { WORKSPACE_DEFAULT_TOV_ANALYZER_FOR_TOOL_FRAGMENT } from './schema';

const QUERY = gql`
  query WorkspaceDefaultTovAnalyzerForTool($customerId: ID!, $id: ID) {
    workspaces(customerId: $customerId, id: $id) {
      edges {
        node {
          ...WorkspaceDefaultTovAnalyzerForTool
        }
      }
    }
  }

  ${WORKSPACE_DEFAULT_TOV_ANALYZER_FOR_TOOL_FRAGMENT}
`;

interface Params {
  customerId: ID;
  id: ID;
}

interface Options {
  abortSignal?: AbortSignal;
}

type Result = Pick<Workspace, 'id' | 'defaultTovAnalyzerForTool'>;

export const queryWorkspaceDefaultTovAnalyzerForTool = async (
  { customerId, id }: Params,
  options?: Options
) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: { customerId, id },
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  const data = getSingleProp<GraphQLEdgesResult<Result>>(result.data);
  const items = unwrapEdges(data?.edges);
  return items[0];
};
